import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

function ParentCategoryGroups() {
  const [PCGName, setPCGName] = useState("");
  const [parentgroup, setParentgroup] = useState([]);
  const [existingNames, setExistingNames] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [MinCartValue, setMinCartValue] = useState("");

  const getParentgroup = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategoryGroup/GetParentcategory`
      );
      setParentgroup(response?.data?.Data);
      // Extract existing names from parentgroup
      const names = response?.data?.Data.map((item) => item.PCGName);
      setExistingNames(names);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteParentGroup = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ParentCategoryGroup/DeleteParentCategory/${_id}`
        );
        console.log("DELETE Response:", response);

        setParentgroup(parentgroup.filter((item) => item._id !== _id));

        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddParentGroup = async (event) => {
    event.preventDefault();
    try {
      if (editItemId) {
        const response = await privateRequest.put(
          `ParentCategoryGroup/UpdateParentcategory/${editItemId}`,
          {
            PCGName,
            MinCartValue,
          }
        );
        console.log("PUT Response:", response);
        setEditItemId(null); // Reset editItemId after updating
      } else {
        // If editItemId is null, perform add operation
        if (existingNames.includes(PCGName)) {
          Swal.fire({
            icon: "error",
            title: "Name Already Exists",
            text: "Please enter another name.",
          });
          return;
        }
        const response = await privateRequest.post(
          `ParentCategoryGroup/AddParentcategory`,
          {
            PCGName,
            MinCartValue,
          }
        );
        console.log("POST Response:", response);
      }
      getParentgroup();
      setEditItemId("");

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: editItemId
          ? "Parent category group updated successfully!"
          : "Parent category group added successfully!",
      });
      setPCGName("");
      setMinCartValue("");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  useEffect(() => {
    getParentgroup();
  }, []);

  return (
    <>
      {parentgroup.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">
                        Parent Category Group
                      </span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      // data-toggle="modal"
                      // data-target="#addAreaModal"
                      onClick={() => {
                        setShowModal(true);

                        setEditItemId("");
                        setPCGName("");
                        setMinCartValue("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">Group Name</th>
                            <th scope="col">Min Cart Value</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parentgroup.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">{item.PCGName}</td>
                              <td className="align-center">
                                ₹ {item.MinCartValue}
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEditItemId(item._id);
                                      setPCGName(item.PCGName);
                                      setMinCartValue(item.MinCartValue);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteParentGroup(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addAreaModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Parent Category Group
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddParentGroup}>
                <div className="form-group">
                  <div className="form-label-group">
                    <input
                      type="text"
                      value={PCGName}
                      onChange={(e) => setPCGName(e.target.value)}
                      id="inputgroupName"
                      className="form-control"
                      placeholder="Group Name"
                    />
                    <label htmlFor="inputgroupName">Group Name</label>
                  </div>
                  <hr className="mt-0" />

                  <div className="form-label-group">
                    <input
                      type="text"
                      value={MinCartValue}
                      onChange={(e) => setMinCartValue(e.target.value)}
                      id="inputgroupName"
                      className="form-control"
                      placeholder="Group Name"
                    />
                    <label htmlFor="inputgroupName">MinCartValue</label>
                  </div>
                </div>
                <div className="form-group text-left">
                  <button type="submit" className="btn btn-primary">
                    {editItemId ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default ParentCategoryGroups;
